/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetBudgetDto } from './GetBudgetDto';
import {
    GetBudgetDtoFromJSON,
    GetBudgetDtoFromJSONTyped,
    GetBudgetDtoToJSON,
} from './GetBudgetDto';

/**
 * 
 * @export
 * @interface GetBrandDto
 */
export interface GetBrandDto {
    /**
     * 
     * @type {string}
     * @memberof GetBrandDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetBrandDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetBrandDto
     */
    name: string;
    /**
     * 
     * @type {GetBudgetDto}
     * @memberof GetBrandDto
     */
    budget: GetBudgetDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetBrandDto interface.
 */
export function instanceOfGetBrandDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "budget" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetBrandDtoFromJSON(json: any): GetBrandDto {
    return GetBrandDtoFromJSONTyped(json, false);
}

export function GetBrandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBrandDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'name': json['name'],
        'budget': GetBudgetDtoFromJSON(json['budget']),
        'active': json['active'],
    };
}

export function GetBrandDtoToJSON(value?: GetBrandDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'name': value.name,
        'budget': GetBudgetDtoToJSON(value.budget),
        'active': value.active,
    };
}

